import React, { lazy, Suspense } from 'react';

const LazySettingSMS = lazy(() => import('./SettingSMS'));

const SettingSMS = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazySettingSMS {...props} />
  </Suspense>
);

export default SettingSMS;
